import { EO, get } from "@green24/npm-javascript-utils";
import { GenericActions } from "../../../actions/GenericActions";
import { StateHandler } from "../../StateHandler";

const defaultInitialState = {
	data: null,
	edit: null,
	fetching: true,
	fetched: false,
	failed: false,
	sending: false,
	error: null,
	deleted: null,
	lastUpdate: undefined,
};

export class ItemStateHandler extends StateHandler {
	static get model() {
		return {
			defaultInitialState,
		}
	}

	constructor({actionPrefix, initialState = defaultInitialState, editOnly = false, sendingAsFetching = false}) {
		super({initialState, defaultInitialState});

		this.actionPrefix = actionPrefix;
		this.editOnly = editOnly;
		this.sendingAsFetching = sendingAsFetching;
	}

	handleAction(action) {
		const {state, actionPrefix, editOnly, sendingAsFetching, initialState} = this;

		switch (action.type) {
			case `${actionPrefix}_${GenericActions.enum.actionType.FETCH_PENDING}`:
				return {
					...state,
					data: null,
					edit: null,
					fetching: true,
					fetched: false,
					failed: false,
					error: null,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.BACKGROUND_FETCH_PENDING}`:
				return {
					...state,
					fetching: true,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.FETCH_FULFILLED}`:
				return {
					...state,
					data: !editOnly ? action.payload : null,
					edit: editOnly ? action.payload : null,
					fetched: true,
					fetching: false,
					lastUpdate: new Date(),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.FETCH_REJECTED}`:
				return {
					...state,
					fetching: false,
					failed: true,
					error: action.payload,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_INIT}`:
				return {
					...state,
					edit: action.payload || EO(state.data).clone(true),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_SET}`:
				return {
					...state,
					edit: action.payload,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_CANCEL}`:
				return {
					...state,
					edit: null,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_MODIFY}`:
				return {
					...state,
					...this._handleModify(state, action),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_PENDING}`:
				return {
					...state,
					...(sendingAsFetching ? {fetching: true} : {sending: true}),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_FULFILLED}`:
				return {
					...state,
					...(sendingAsFetching ? {fetching: false} : {sending: false}),
					data: !editOnly ? EO(action.payload).clone(true) : null,
					edit: editOnly ? EO(action.payload).clone(true) : null,
					lastUpdate: new Date(),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.ITEM_DELETE}`:
				return {
					...state,
					deleted: get(action, `payload.id`),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.EDIT_REJECTED}`:
				return {
					...state,
					...(sendingAsFetching ? {fetching: false} : {sending: false}),
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.ITEM_CLEAR}`:
				return {
					...initialState,
				};
			case `${actionPrefix}_${GenericActions.enum.actionType.CACHE_CLEAR}`:
				return {
					...state,
					lastUpdate: undefined,
				};
			default:
				return state;
		}
	}

	_handleModify(state, {modification = {}}) {
		const {type, path, value} = modification;
		let newEditData = EO(state.edit).clone(true);
		newEditData.modify(type, path, value);

		return {
			edit: newEditData,
		};
	}
}
